import { Injectable } from '@angular/core';
import { ActiveCartService } from '@cart/data-access';
import { Cart } from '@spartacus/core';
import { Observable, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomCartPageLayoutHandler {
  constructor(private activeCartService: ActiveCartService) {}

  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string): Observable<string[]> {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      return combineLatest({
        slots: slots$,
        cart: this.activeCartService.getActive(),
        selectiveCart: of({} as Cart),
        loadingCart: this.activeCartService.getLoading(),
      }).pipe(
        map(({ slots, cart, selectiveCart, loadingCart }) => {
          const exclude = (arr: string[], args: string[]): string[] =>
            arr.filter((item: string) => args.every((arg: string) => arg !== item));

          return Object.keys(cart).length === 0 && loadingCart
            ? exclude(slots, ['TopContent', 'CenterRightContentSlot', 'EmptyCartMiddleContent'])
            : cart.totalItems
              ? exclude(slots, ['EmptyCartMiddleContent'])
              : selectiveCart.totalItems
                ? exclude(slots, ['EmptyCartMiddleContent', 'CenterRightContentSlot'])
                : exclude(slots, ['TopContent', 'CenterRightContentSlot', 'BottomContentSlot']);
        }),
      );
    }

    return slots$;
  }
}
